// Screen 5 (spec 13 §Screens): the gate dashboard at `/operator/gate?as_of=YYYY-MM-DD`. Agency
// operators only: anyone else gets the not-found page and the screen issues no API call (the
// API answers 404 to them as well).
import { createRoute, useNavigate } from "@tanstack/react-router";
import { isOperator } from "../features/company";
import { GateDashboard } from "../features/gate/gate-dashboard";
import { useSession } from "../features/use-feature";
import { NotFoundPage } from "../pages/status-pages";
import { OperatorShell, PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";

const DATE = /^\d{4}-\d{2}-\d{2}$/;

export const operatorGateRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator/gate",
  validateSearch: (search: Record<string, unknown>): { as_of?: string } => {
    const v = search.as_of;
    return typeof v === "string" && DATE.test(v) && !Number.isNaN(Date.parse(v))
      ? { as_of: v }
      : {};
  },
  component: GateScreen,
});

function GateScreen() {
  const { api } = operatorGateRoute.useRouteContext();
  const { as_of } = operatorGateRoute.useSearch();
  const navigate = useNavigate();
  const { me } = useSession();
  if (!isOperator(me)) {
    return (
      <PlainShell me={me} api={api} current={null}>
        <NotFoundPage />
      </PlainShell>
    );
  }
  return (
    <OperatorShell me={me} api={api}>
      <GateDashboard
        api={api}
        asOf={as_of ?? null}
        onAsOf={(v) => void navigate({ to: "/operator/gate", search: v ? { as_of: v } : {} })}
      />
    </OperatorShell>
  );
}
